import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { jsx as _jsx } from "react/jsx-runtime";
export const EmptyComponent = () => /*#__PURE__*/_jsx(LoadingSpinner, {
  size: "medium"
});